import React from 'react';

import NowDatePicker from './NowDatePicker';
import { trans } from '../../localization';

class FromToDatePicker extends React.Component {
  handleChangeFromDate = (fromDate) => {
    const { toDate, handleChangeFromDate, handleChangeToDate } = this.props;
    if (fromDate > toDate) {
      handleChangeToDate(fromDate, false);
      handleChangeFromDate(fromDate);
    } else {
      handleChangeFromDate(fromDate);
    }
  };

  handleChangeToDate = (toDate) => {
    const { fromDate, handleChangeFromDate, handleChangeToDate } = this.props;
    if (toDate < fromDate) {
      handleChangeFromDate(toDate, false);
      handleChangeToDate(toDate);
    } else {
      handleChangeToDate(toDate);
    }
  };

  render() {
    const { fromDate, toDate } = this.props;
    return (
      <div className="form-inline">
        <div className="form-group">
          <label className="col-form-label pr-1">{trans('from')}</label>
          <NowDatePicker
            width={110}
            value={fromDate}
            onChange={selectedDates =>
              this.handleChangeFromDate(selectedDates[0])
            }
          />
        </div>
        <div className="form-group ml-1">
          <label className="col-form-label pr-1">{trans('to')}</label>
          <NowDatePicker
            width={110}
            value={toDate}
            onChange={selectedDates =>
              this.handleChangeToDate(selectedDates[0])
            }
          />
        </div>
      </div>
    );
  }
}

export default FromToDatePicker;



// WEBPACK FOOTER //
// ./foody/src/components/Common/FromToDatePicker.jsx